export default __webpack_public_path__ + "static/media/collapse-off.d6eb6cac.svg";